import React from 'react'
import {
  HInput,
  HRadio,
  passParamsThrough,
  HCheckbox
} from '../../../validation/HForm'
import { translationRuEnSameLetters } from '../../../helpers/common';
import {Message} from "../index";

const UserInfoAdd = ({ register, errors, setValue, defaultValue, error, onFocus, commonError }) => {

  return (
    passParamsThrough(
      <div>
        {commonError && <Message type="error" text={commonError} />}
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="lastName">Фамилия</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="user.lastName" id="lastName"/>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="firstName">Имя</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="user.firstName" id="firstName"/>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="middleName">Отчество</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="user.middleName" id="middleName"/>
              </div>
            </div>
          </div>
        </div>
        <div className="form-element">
          <label className="form-element-label" htmlFor="gender">Пол</label>
          <div className="form-element-data">
            <div className="form-element-data-radios clientInfoAdd-radio">
              <HRadio
                h="true"
                labels={['Мужской', 'Женский']}
                name={'user.gender'}
              />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="position">Должность</label>
              <div className="form-element-data">
                <HInput h="true" className="input" type="text" name="user.position" id="position"/>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="emplPersonalNum">Личный номер</label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className={error ? "input input-error" : "input"}
                  type="text"
                  name="user.emplPersonalNum"
                  id="emplPersonalNum"
                  onChange={(event) => translationRuEnSameLetters(event, setValue, "user.emplPersonalNum", true)}
                  defaultValue={defaultValue || ''}
                  onFocus={onFocus}
                />
                {error ? <span className="form-message error">{error}</span> : ''}
              </div>
            </div>
          </div>
        </div>
        <div className="form-element">
          <label className="form-element-label" htmlFor="active">Активен</label>
          <div className="form-element-data">
            <HCheckbox h="true" label="Активен"
                       name="user.active"/>
          </div>
        </div>
      </div>, { register, errors })
  )
}

export default UserInfoAdd
